export class LookbookPage {
  init(): void {
    // LOOK BOOK ページ
  }
}
